import axiosClient from './axiosClient';

export const redeemReward = async (itemIndex) => {
  try {
    const response = await axiosClient.post('v1/redeem-item', {
      item: itemIndex + 1, // Send item index + 1 in the body
    });
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
};

export const completeRedemption = async (data) => {
  try {
    const response = await axiosClient.post('v1/redeem-claim', JSON.stringify(data));
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}

export const callGameNow = async (data) => {
  try {
    const response = await axiosClient.post('v1/gamenow/notify', JSON.stringify(data));
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}

export const getRewardsList = async () => {
  try {
    const response = await axiosClient.post('v1/rewards');
    return response;
  } catch (error) {
    throw error.response?.data || { success: false, errors: true, data: { message: 'An error occurred' } };
  }
}